import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  hasBaseline: boolean;
  saving: boolean;
  onClose: () => void;
  onSave: (action: 'overwrite' | 'snapshot') => Promise<void>;
}

export default function ScheduleBaselineModal({ show, hasBaseline, saving, onClose, onSave }: Props) {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-white w-full max-w-sm rounded-3xl overflow-hidden mx-4">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-[#1A1A1A] font-bold text-base">
            {hasBaseline ? t('baselineModal.baselineExists') : t('baselineModal.setBaseline')}
          </h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 cursor-pointer">
            <i className="ri-close-line text-[#374151]"></i>
          </button>
        </div>
        <div className="px-5 py-4 space-y-3">
          <p className="text-[#6B7280] text-sm leading-relaxed">
            {hasBaseline ? t('baselineModal.existsDesc') : t('baselineModal.noBaselineDesc')}
          </p>
        </div>
        <div className="px-5 py-4 border-t border-gray-100 flex flex-col gap-2">
          {hasBaseline ? (
            <>
              <button
                onClick={() => onSave('overwrite')}
                disabled={saving}
                className="w-full py-3 rounded-xl bg-[#E8621A] text-white text-sm font-bold cursor-pointer whitespace-nowrap disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {saving ? <><i className="ri-loader-4-line animate-spin"></i>...</> : t('baselineModal.overwriteAndSnapshot')}
              </button>
              <button
                onClick={() => onSave('snapshot')}
                disabled={saving}
                className="w-full py-3 rounded-xl bg-white border border-gray-200 text-[#374151] text-sm font-bold cursor-pointer whitespace-nowrap disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {saving ? <><i className="ri-loader-4-line animate-spin"></i>...</> : t('baselineModal.snapshotOnly')}
              </button>
              <button
                onClick={onClose}
                className="w-full py-2 rounded-xl text-[#9CA3AF] text-xs font-bold cursor-pointer whitespace-nowrap"
              >
                {t('baselineModal.cancel')}
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => onSave('overwrite')}
                disabled={saving}
                className="w-full py-3 rounded-xl bg-[#E8621A] text-white text-sm font-bold cursor-pointer whitespace-nowrap disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {saving ? <><i className="ri-loader-4-line animate-spin"></i>...</> : t('baselineModal.setBaselineBtn')}
              </button>
              <button
                onClick={onClose}
                className="w-full py-2 rounded-xl text-[#9CA3AF] text-xs font-bold cursor-pointer whitespace-nowrap"
              >
                {t('baselineModal.cancel')}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}